// removed by extract-text-webpack-plugin
module.exports = {"mobileNav":"_1w-ZoO-yMauKbdVl3qSVOv","heading":"i6Z9j-yoMUfz3cTbvzSM8","content":"_2si7FFnbGDUxEOodlCJwOI","links":"_3bfTepUwZF6VPb1jDCxaSe","link":"_2952ql2yfQt0vdRLWxs4y6","selector":"UA8r0oQROHlwufrYtst4f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileSidebar/style.css
// module id = 668
// module chunks = 0